import { createSlice } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { createWordSearch, getWordSearches, updateWordSearch, updateWords, deleteWordSearch, updateWordSearchStatus, getWordSearch, } from '../actions/word-searches';
const initialState = {
    wordSearches: [],
    activeFilter: {},
    wordSearchDetail: null,
    loading: false,
    error: false,
    errorDetail: '',
    lastCreatedWordSearchId: null,
};
const wordSearchesSlice = createSlice({
    name: 'wordSearches',
    initialState,
    reducers: {
        setActiveFilter: (state, action) => {
            state.activeFilter = action.payload;
        },
        setlastCreatedWordSearchId: (state, action) => {
            state.lastCreatedWordSearchId = action.payload.wordSearchId || null;
        },
        clearError: (state, _action) => {
            state.error = false;
            state.errorDetail = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWordSearches.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(getWordSearches.fulfilled, (state, action) => {
            state.wordSearches = action.payload.wordSearches;
            state.loading = false;
            state.error = false;
        })
            .addCase(getWordSearches.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(createWordSearch.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(createWordSearch.fulfilled, (state, action) => {
            const { wordSearchId = v4(), name = '', duration, } = action.payload.wordSearch;
            const newWordSearch = {
                wordSearchId,
                name,
                duration,
                status: 'draft',
                wordsCount: 0,
                submissionsCount: 0,
            };
            state.wordSearches = [...state.wordSearches, newWordSearch];
            state.loading = false;
            state.error = false;
            state.lastCreatedWordSearchId = newWordSearch.wordSearchId;
        })
            .addCase(createWordSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(updateWordSearch.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(updateWordSearch.fulfilled, (state, action) => {
            const { wordSearchId, name, duration, settings } = action.payload;
            const wordSearch = state.wordSearches.find((wordSearch) => wordSearch.wordSearchId === wordSearchId);
            if (wordSearch) {
                wordSearch.name = name;
                wordSearch.duration = duration;
            }
            if (state.wordSearchDetail) {
                state.wordSearchDetail.name = name;
                state.wordSearchDetail.duration = duration;
                state.wordSearchDetail.settings = settings;
            }
            state.loading = false;
            state.error = false;
        })
            .addCase(updateWordSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(getWordSearch.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(getWordSearch.fulfilled, (state, action) => {
            state.wordSearchDetail = action.payload.wordSearch;
            state.loading = false;
            state.error = false;
        })
            .addCase(getWordSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(updateWordSearchStatus.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(updateWordSearchStatus.fulfilled, (state, action) => {
            const { wordSearchId, status, code } = action.payload;
            const wordSearch = state.wordSearches.find((wordSearch) => wordSearch.wordSearchId === wordSearchId);
            if (wordSearch) {
                wordSearch.status = status;
                wordSearch.code = code;
            }
            if (state.wordSearchDetail) {
                state.wordSearchDetail.code = code;
                state.wordSearchDetail.status = status;
            }
            state.loading = false;
            state.error = false;
        })
            .addCase(updateWordSearchStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(deleteWordSearch.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(deleteWordSearch.fulfilled, (state, action) => {
            const { wordSearchId } = action.payload;
            state.wordSearches = state.wordSearches.filter((wordSearch) => wordSearch.wordSearchId !== wordSearchId);
            state.loading = false;
            state.error = false;
        })
            .addCase(deleteWordSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(updateWords.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(updateWords.fulfilled, (state, action) => {
            const { words, wordSearchId } = action.payload;
            if (state.wordSearchDetail) {
                state.wordSearchDetail.words = words;
            }
            const wordSearch = state.wordSearches.find((wordSearch) => wordSearch.wordSearchId === wordSearchId);
            if (wordSearch) {
                wordSearch.wordsCount = words.length;
            }
            state.loading = false;
            state.error = false;
        })
            .addCase(updateWords.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        });
    },
});
export const { setActiveFilter, setlastCreatedWordSearchId, clearError } = wordSearchesSlice.actions;
export { wordSearchesSlice };
